//
// const SIDE_ITEMS =[
//    { header: "Admin" },
//    { icon: "business", title: "Manage Agencies", name: "ManageGroups" },
//    { icon: "business", title: "Manage Organizations", name: "ManageGroups" },
//    { icon: "directions_car", title: "Manage Dealerships", name: "ManageDealers" },
//    { icon: "account_circle", title: "Manage Users", name: "ManageUsers" },
//    { icon: "school", title: "Manage Curriculum", name: "ManageQuestions" },
//
//    {header: "Account Management"},
//    { icon: "turned_in", title: "Grade ISM", name: "GradeISM" },
//    { icon: "trending_up", title: "Grade Report", name: "GradeReport" },
//
//    {header: "Client Portal"},
//    { icon: "account_circle", title: "Manage Users", name: "BlankPage2" },
//    { icon: "trending_up", title: "Reporting Dashboard", name: "BlankPage" },
//
// ];




/**
 *
 * @param profile - "profile" property of this.$auth object (see def of AuthService class def)
 */
function getSideBarItems0(profile){

   // console.log(profile);


   let sidebar;

   // let acct_type = profile['https://taskteacher.dealerknows.com/acct_type'];
   // let user_role = profile['https://taskteacher.dealerknows.com/user_role'];

   let acct_type = profile.acct_type;
   let user_role = profile.user_role;

   if (user_role === 'SuperAdmin') {
      sidebar = [
         { header: "Admin" },
         // { icon: "business", title: "Manage Agencies", name: "ManageGroups" },
         { title: "Manage Organizations", name: "ManageGroups",  icon: "business"},
         { title: "Manage Dealerships", name: "ManageDealers" , icon: "directions_car"},
         { title: "Manage Users", name: "ManageUsers", icon: "account_circle" },
         { title: "Manage Curriculum", name: "ManageQuestions", icon: "school",  },
         { title: "Manage Graders", name: "ManageGraders", icon: "account_circle",  },

         {header: "Account Management"},
         { title: "Grade ISM", name: "GradeISM", icon: "turned_in",  },
         { title: "Grade Report", name: "GradeReport", icon: "trending_up" },
         { title: "Report Card", name: "ReportCard", icon: "trending_up" },
      ];
   }
   else{
      if (acct_type === 'AGENCY') {
         if (user_role === 'Admin') {
            sidebar = [
               {header: "Admin"},
               { title: "Manage Organizations", name: "ManageGroups",  icon: "business"},
               { title: "Manage Dealerships", name: "ManageDealers" , icon: "directions_car"},
               { title: "Manage Users", name: "ManageUsers", icon: "account_circle" },
               { title: "Manage Curriculum", name: "ManageQuestions", icon: "school",  },
               { title: "Manage Graders", name: "ManageGraders", icon: "account_circle",  },

               {header: "Account Management"},
               { title: "Manager Home", name: "AdminHome", icon: "home",  },
               { title: "Grader Home", name: "GraderHome", icon: "home",  },
               { title: "Grade ISM", name: "GradeISM", icon: "turned_in",  },
               { title: "Grade Report", name: "GradeReport", icon: "trending_up" },
               { title: "Report Card", name: "ReportCard", icon: "trending_up" },
               { title: "Analytics", name: "Analytics", icon: "trending_up" },

               {header: "Manager Teacher"},
               { title: "Coach-Up", name: "CoachupQue", icon: "school" },
               { title: "Coach-Up Summary", name: "CoachupRanking", icon: "school" },
               { title: "Report Card", name: "CoachupReportCard", icon: "trending_up" },

               // { title: "Coach Up", name: "GradeCoachUp", icon: "school" },

            ];
         }
         else if (user_role === 'AcctManager') {
            sidebar = [
               {header: "Admin"},
               { title: "Manage Organizations", name: "ManageGroups",  icon: "business"},
               { title: "Manage Dealerships", name: "ManageDealers" , icon: "directions_car"},
               { title: "Manage Users", name: "ManageUsers", icon: "account_circle" },
               { title: "Manage Curriculum", name: "ManageQuestions", icon: "school",  },
               { title: "Manage Graders", name: "ManageGraders", icon: "account_circle",  },


               {header: "Account Management"},
               { title: "Home", name: "GraderHome", icon: "account_circle",  },
               { title: "Grade ISM", name: "GradeISM", icon: "turned_in",  },
               { title: "Grade Report", name: "GradeReport", icon: "trending_up" },
               // { title: "Report Card", name: "ReportCard", icon: "trending_up" },
            ];
         }
         else if (user_role === 'Grader') {
            sidebar = [
               {header: "Account Management"},
               { title: "Home", name: "GraderHome", icon: "account_circle",  },
               { title: "Grade ISM", name: "GradeISM", icon: "turned_in",  },
               { title: "Grade Report", name: "GradeReport", icon: "trending_up" },
            ];
         }
      }//if AGENCY

      else if (acct_type === 'CLIENT') {
         if (user_role === 'Admin') {
            sidebar = [
               {header: "Admin"},
               { title: "Manage Dealerships", name: "ManageDealers" , icon: "directions_car"},
               { title: "Manage Users", name: "ManageUsers", icon: "account_circle" },

               {header: "Reporting"},
               { title: "Grade Report", name: "GradeReport", icon: "trending_up" },
               { title: "Report Card", name: "ReportCard", icon: "trending_up" },
               { title: "Analytics", name: "Analytics", icon: "trending_up" },

               {header: "Manager Teacher"},
               { title: "Coach-Up", name: "CoachupQue", icon: "school" },

            ];
         }

         else if (user_role === 'Executive') {
            sidebar = [
               {header: "Reporting"},
               { title: "Grade Report", name: "GradeReport", icon: "trending_up" },
               // { title: "Report Card", name: "ReportCard", icon: "trending_up" },
               { title: "Analytics", name: "Analytics", icon: "trending_up" },

               {header: "Manager Teacher"},
               { title: "Coach-Up", name: "CoachupQue", icon: "school" },
               { title: "Coach-Up Summary", name: "CoachupRanking", icon: "school" },


            ];
         }

         else if (user_role === 'Manager') {
            sidebar = [
               {header: "Reporting"},
               { title: "Grade Report", name: "GradeReport", icon: "trending_up" },
               // { title: "Report Card", name: "ReportCard", icon: "trending_up" },
               { title: "Analytics", name: "Analytics", icon: "trending_up" },

               {header: "Manager Teacher"},
               { title: "Coach-Up", name: "CoachupQue", icon: "school" },
            ];
         }
         else if (user_role === 'SalesPerson') {
            sidebar = [
               {header: "Reporting"},
               { title: "Grade Report", name: "GradeReport", icon: "trending_up" },
               { title: "Analytics", name: "Analytics", icon: "trending_up" },

            ];
         }


      }// if CLIENT
   }// else (not SuperAdmin)

   return sidebar;
}

export const getSideBarItems = getSideBarItems0;













// export default
